import * as Vue from "vue-tsx-support";
import "vue-tsx-support/enable-check"
import iView from 'lb-iview'

let IView: any = iView

export interface IconProps {
	/**
	 * 图标的名称
	 */
	type?: string;
	/**
	 * 图标的大小，单位是 px
	 */
	size?: number | string;
	/**
	 * 图标的颜色
	 */
	color?: string;
}


const Icon = Vue.ofType<IconProps,{onClick:(e:any)=>void,stopOnClick:()=>{}}>().convert(IView.Icon);
export default Icon


